angular.module('app.cessao').factory('integracaoCessaoRemessaFactory', function ($http, errorService) {
    var _apiName = 'IntegracaoCessaoRemessa';

    var _listarRemessasIntegracao = function (options, dataInicio, dataTermino, stituacaoIntegracao, produtoRede, tipoLayoutFundo, search) {
        var dto = options.data;
        dto.parms = [];
        dto.search = search;
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": stituacaoIntegracao });
        dto.parms.push({ "name": "ProdutoRede", "value": produtoRede });
        dto.parms.push({ "name": "TipoLayoutFundo", "value": tipoLayoutFundo })
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarRemessasIntegracao', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _reprocessar = function (codigo) {
        var dto = {};
        dto.id = codigo;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Reprocessar', dto);
    };

    var _listarSituacoes = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarSituacoes');
    };

    var _obterCallbacksIntegracaoRemessa = function (options, id) {
        var dto = {};
        dto.id = id;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ObterCallbacksIntegracaoRemessa', dto)
    };

    var factory = {};

    factory.listarRemessasIntegracao = _listarRemessasIntegracao;
    factory.reprocessar = _reprocessar;
    factory.listarSituacoes = _listarSituacoes;
    factory.obterCallbacksIntegracaoRemessa = _obterCallbacksIntegracaoRemessa;

    return factory;
});